export const isShowForThisPage = (route: string, price: number, minPriceShow: number): boolean => {
  if (route === '/mycart' || ['/catalog/tyres/[brand]/[model]/[product]', '/catalog/discs/[slug]/[model]/[product]'].includes(route)) {
    return price ? price * 4 >= minPriceShow : true;
  }
  return false;
};
